
import Component from "vue-class-component";
import Vue from "vue";
import { namespace } from "vuex-class";
import { Watch } from "vue-property-decorator";
import QuestionDialogComponent from "@/components/dialogs/QuestionDialog.vue";
import UserService from "@/services/UserService";

const initialModelState = {
  senhaAtual: "",
  novaSenha: "",
  novaSenhaVerif: "",
};
const Notifications = namespace("Notifications");

@Component({
  props: {
    username: {
      type: String,
      required: true,
      default: "",
    },
  },

  components: {
    QuestionDialogComponent,
  },
})
export default class AlteracaoSenhaUsuarioDialogComponent extends Vue {
  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  private model = { ...initialModelState };

  regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    minChars: (v: string) => {
      return (v && v.length >= 8) || "Mínimo de 8 caracteres";
    },
  };

  get passwordConfirmationRule() {
    return () => this.model.novaSenha === this.model.novaSenhaVerif || "Senhas não coincidem";
  }

  private valid = false;
  private dlgVisible = false;
  private isLoading = false;

  private pwdBtn = {
    atual: false,
    reg: false,
    regVerif: false,
  };

  show() {
    this.model = { ...initialModelState };
    this.dlgVisible = true;
    this.isLoading = false;
    this.valid = false;
  }

  onAprovarClick() {
    if (this.valid) {
      this.isLoading = true;
      const dlg = this.$refs.questionDlgVis as QuestionDialogComponent;
      dlg.show(null, {
        title: "Alteração de senha",
        message:
          "Você precisará efetuar login no portal novamente após a troca de senha. Deseja continuar?",
      });
    }
  }

  cancelarEnvio() {
    this.isLoading = false;
  }

  handleAprovacao() {
    UserService.passwordSetNewPassword({
      user: this.$props.username,
      newPassword: this.model.novaSenha,
      oldPwd: this.model.senhaAtual,
    })
      .then(() => {
        this.showInfoMessage("Alteração de senha solicitada com sucesso");
        this.$emit("onAlteracaoSenhaCommit");
      })
      .catch((error) => {
        this.showErrorMessage(
          "Falha ao solicitar alteração de senha: " + error.response.data || error.message || error
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
